import { selection } from "d3-selection";
import selection_interrupt from "./interrupt.js";
import selection_transition from "./transition.js";
selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-transition@1.3.2@d3-transition/src/selection/index.js
// module id = 458
// module chunks = 0